import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { FormField, RadioGroup, RadioOld } from "@/component-library";

import "./styles.scss";

export const OPTIONS = [
  {
    label: "This event",
    value: "this_event",
  },
  {
    label: "This and future events",
    value: "this_and_future_events",
  },
];

export const RECURRING_AVAILABILITY_VALUE = OPTIONS[1].value;

export const CalendarDeleteSeriesModalContent = ({ deleteSeriesOnChange, deleteSeriesValue }) => {
  return (
    <>
      <FormField label="Cancel" labelClassName="CalendarDeleteModalRecurringContent--title">
        <RadioGroup
          className="CalendarDeleteModalRecurringContent--radio_group"
          name="delete_series"
          onChange={deleteSeriesOnChange}
        >
          <RadioOld
            checked={deleteSeriesValue === OPTIONS[0].value}
            label={OPTIONS[0].label}
            labelClassName="CalendarDeleteModalRecurringContent--radio_button"
            value={OPTIONS[0].value}
          />

          <RadioOld
            checked={deleteSeriesValue === OPTIONS[1].value}
            label={OPTIONS[1].label}
            labelClassName="CalendarDeleteModalRecurringContent--radio_button"
            value={OPTIONS[1].value}
          />
        </RadioGroup>
      </FormField>
    </>
  );
};

export const ScheduleDeleteSeriesModal = ({
  children,
  deleteSeriesValue,
  disableSubmit,
  onCancel,
  onCancelText,
  onSubmit,
  onSubmitText,
  showSubTitleOnNewLine,
  subTitle,
  title,
}) => {
  const computedSubmitText =
    onSubmitText ||
    (deleteSeriesValue === OPTIONS[1].value ? "Cancel Future Events" : "Cancel Event");

  return (
    <div className="CalendarDeleteModal--body">
      <div className="CalendarDeleteModal--inner tw:min-w-130">
        <div className="CalendarDeleteModal--title_wrapper">
          <h2 className="CalendarDeleteModal--title">{title}</h2>
          {!showSubTitleOnNewLine && <p className="CalendarDeleteModal--sub_title">{subTitle}</p>}
        </div>

        {showSubTitleOnNewLine && <p className="CalendarDeleteModal--sub_title">{subTitle}</p>}
        {children}

        <div className="tw:grid tw:grid-cols-2 tw:gap-5">
          {/* Wrap handlers in arrow functions to prevent Button2 from passing event objects that cause circular structure errors in Redux */}
          <Button2 onPress={() => onCancel()} variant="secondary">
            {onCancelText}
          </Button2>

          <Button2 isDisabled={disableSubmit} onPress={() => onSubmit()}>
            {computedSubmitText}
          </Button2>
        </div>
      </div>
    </div>
  );
};
